import { render, staticRenderFns } from "./BerkleyPolicyDetailFacts.vue?vue&type=template&id=3e07d197"
import script from "./BerkleyPolicyDetailFacts.vue?vue&type=script&lang=js"
export * from "./BerkleyPolicyDetailFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports